var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.useProvider ? 'nuxt-img' : 'img',{tag:"component",staticClass:"lazy-image",attrs:{"src":_vm.transformedSrc,"alt":_vm.alt,"srcset":_vm.srcset,"width":_vm.width,"height":_vm.height,"loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }